function isMatchingCriteria(feedback, criteria) {
  return feedback.criteria_node_id === criteria.id && feedback.data.criteria_node.grading_value_type === criteria.grading_value_type;
}
function findMatchingCriteriaFeedback(feedback, criteria) {
  return feedback?.findLast((f) => isMatchingCriteria(f, criteria));
}
function filterMatchingCriteriaFeedback(feedback, criteria) {
  if (!feedback) return [];
  return feedback.filter((f) => isMatchingCriteria(f, criteria));
}
function isMatchingSection(feedback, sectionId) {
  return feedback.criteria_node_id === sectionId && feedback.data.criteria_node.grading_value_type === "section";
}
function findMatchingSectionFeedback(feedback, sectionId) {
  return feedback?.findLast((f) => isMatchingSection(f, sectionId));
}
function filterMatchingSectionFeedback(feedback, sectionId) {
  if (!feedback) return [];
  return feedback.filter((f) => isMatchingSection(f, sectionId));
}
const sectionIsNotApplicableValueToDisplayValue = (isNotApplicable) => isNotApplicable ? "N/A" : "Applicable";
export {
  filterMatchingCriteriaFeedback,
  filterMatchingSectionFeedback,
  findMatchingCriteriaFeedback,
  findMatchingSectionFeedback,
  sectionIsNotApplicableValueToDisplayValue
};
//# sourceMappingURL=recordingAssessmentFeedbackHelpers.js.map
